import React from "react";
import { useLocalization } from "../../context/LocalizationContext";
import { generateDeclinedItemsReport } from "../../shared/helpers/excelGenerator";
import { formatCategoryName } from "../../shared/helpers/categoryFormatter";

const DeclinedRepairOrdersModal = ({ isOpen, onClose, declinedItems = [], rowData = null }) => {
  const { t: localization } = useLocalization();

  if (!isOpen) return null;

  const hasDeclinedItems = declinedItems && declinedItems.length > 0;

  const handleDownloadDeclinedItemsReport = () => {
    if (!hasDeclinedItems) {
      return;
    }
    const orderDetails = {
      customerName: rowData?.customerName || 'N/A',
      vehicle: `${rowData?.year || ''} ${rowData?.make || ''} ${rowData?.model || ''}`.trim() || 'N/A',
      date: rowData?.createdDate ? new Date(rowData.createdDate).toLocaleDateString() : 'N/A',
      shop: rowData?.dealerShipName || 'N/A',
    };

    generateDeclinedItemsReport(declinedItems, rowData?.repairOrderId, orderDetails);
  };

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title fw-bold">
              {localization("declined_repair_items")}
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label={localization("close")}
            />
          </div>

          <div className="modal-body">
            {!hasDeclinedItems ? (
              <div className="text-center py-5">
                <p className="text-muted">
                  {localization("no_items_declined")}
                </p>
              </div>
            ) : (
              <>
                <table className="table table-hover table-bordered mb-3">
                  <thead className="bg-black text-white">
                    <tr>
                      <th style={{ backgroundColor: "#6d757d", color: "#ffffff" }}>Sr No.</th>
                      <th style={{ backgroundColor: "#6d757d", color: "#ffffff" }}>
                        {localization("service_name")}
                      </th>
                      <th style={{ backgroundColor: "#6d757d", color: "#ffffff" }}>{localization("category")}</th>
                      <th style={{ backgroundColor: "#6d757d", color: "#ffffff" }}>{localization("price")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {declinedItems.map((item, index) => (
                      <tr key={index}>
                        <td className="fw-500">
                          {index + 1}
                        </td>
                        <td className="fw-500">
                          {item.serviceName ||
                            localization("unnamed_service")}
                        </td>
                        <td>
                          <span >
                            {formatCategoryName(item.serviceCategory)}
                          </span>
                        </td>
                        <td >
                          {typeof item.price === "number"
                            ? `$${item.price.toFixed(2)}`
                            : "N/A"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {/* <div className="alert alert-info mb-0">
                  <p className="mb-2">
                    <strong>{localization("total_declined_items")}:</strong>{" "}
                    {declinedItems.length}
                  </p>
                  {declinedItems.length > 0 && (
                    <p className="mb-0">
                      <strong>
                        {localization("total_declined_value")}:
                      </strong>{" "}
                      $
                      {declinedItems
                        .reduce((sum, item) => sum + (item.price || 0), 0)
                        .toFixed(2)}
                    </p>
                  )}
                </div> */}
              </>
            )}
          </div>

          <div className="modal-footer">
            {hasDeclinedItems && (
              <button
                type="button"
                className="btn btn-success"
                onClick={handleDownloadDeclinedItemsReport}
                title={localization("download")}
              >
                <i className="fas fa-download me-1"></i>  {" "} {localization("download")}
              </button>
            )}
            <button
              type="button"
              className="btn btn-cancel"
              onClick={onClose}
              title={localization("close")}
            >
              {localization("close")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeclinedRepairOrdersModal;
